// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard_dashboard__3ppNt","ldsRoller":"Dashboard_ldsRoller__3o14-","lds-roller":"Dashboard_lds-roller__3HbdL"};